<template>
    <section>
        <div class="cbp-form">
            <h3>Payment Information</h3>

            <div id="paymentErrors" role="alert"></div>
            <form id="formPayment">
                <div class="row mb-3">
                    <div class="col-12 col-md-3">
                        <strong>Amount Due: </strong>
                    </div>
                    <div class="col-12 col-md-9" v-if="store.estimatedFee != null">
                        ${{ store.estimatedFee }} USD
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-12 col-md-6">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="floatingPaymentFirstName" placeholder="" v-model="store.paymentFirstName" :class="{ 'is-invalid': v$.paymentFirstName.$errors.length > 0 }" />
                            <label for="floatingPaymentFirstName">First name on the card: <span class="required">*</span></label>
                            <div v-for="error of v$.paymentFirstName.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="floatingPaymentLastName" placeholder="" v-model="store.paymentLastName" :class="{ 'is-invalid': v$.paymentLastName.$errors.length > 0 }" />
                            <label for="floatingPaymentLastName">Last name on the card: <span class="required">*</span></label>
                            <div v-for="error of v$.paymentLastName.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                        </div>
                    </div>
                </div>

                <div class="mb-3">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="floatingPaymentAddress1" placeholder="" v-model="store.paymentAddress1" :class="{ 'is-invalid': v$.paymentAddress1.$errors.length > 0 }" />
                        <label for="floatingPaymentAddress1">Address: <span class="required">*</span></label>
                        <div v-for="error of v$.paymentAddress1.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-12 col-md-4">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="floatingPaymentLocality" placeholder="" v-model="store.paymentLocality" :class="{ 'is-invalid': v$.paymentLocality.$errors.length > 0 }" />
                            <label for="floatingPaymentLocality">City: <span class="required">*</span></label>
                            <div v-for="error of v$.paymentLocality.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                        </div>
                    </div>

                    <div class="col-12 col-md-3">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="floatingPaymentRegion" placeholder="" v-model="store.paymentRegion" :class="{ 'is-invalid': v$.paymentRegion.$errors.length > 0 }" />
                            <label for="floatingPaymentRegion">State/Province: <span class="required">*</span></label>
                            <div v-for="error of v$.paymentRegion.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                        </div>
                    </div>

                    <div class="col-12 col-md-3">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="floatingPaymentPostalCode" placeholder="" v-model="store.paymentPostalCode" :class="{ 'is-invalid': v$.paymentPostalCode.$errors.length > 0 }" />
                            <label for="floatingPaymentPostalCode">Zip/Postal Code: <span class="required">*</span></label>
                            <div v-for="error of v$.paymentPostalCode.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                        </div>
                    </div>

                    <div class="col-12 col-md-2">
                        <div class="form-floating">
                            <select class="form-select" id="floatingPaymentCountry" v-model="store.paymentCountry" :class="{ 'is-invalid': v$.paymentCountry.$errors.length > 0 }">
                                <option v-for="(name, code) in store.countries" :value="code" :key="code">{{ name }}</option>
                            </select>
                            <label for="floatingPaymentCountry">Country: <span class="required">*</span></label>
                            <div v-for="error of v$.paymentCountry.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                        </div>
                    </div>

                </div>

                <div class="row mb-3">
                    <div class="col-12 col-md-6">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="floatingPaymentEmail" placeholder="" v-model="store.paymentEmail" :class="{ 'is-invalid': v$.paymentEmail.$errors.length > 0 }" />
                            <label for="floatingPaymentEmail">Email: <span class="required">*</span></label>
                            <div v-for="error of v$.paymentEmail.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-floating">
                            <input type="text" class="form-control" id="floatingPaymentPhone" placeholder="" v-model="store.paymentPhone" :class="{ 'is-invalid': v$.paymentPhone.$errors.length > 0 }" />
                            <label for="floatingPaymentPhone">Phone: <span class="required">*</span></label>
                            <div v-for="error of v$.paymentPhone.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                        </div>
                    </div>
                </div>

                <div class="mb-3">
                    <div class="form-floating">
                        <div id="floatingPaymentCardNumber" class="form-control" :class="{ 'is-invalid': ((cardEmpty != null && cardEmpty) || (cardValid != null && !cardValid)) }"></div>
                        <label for="floatingPaymentCardNumber">Card number: <span class="required">*</span></label>
                        <div v-if="(cardEmpty != null && cardEmpty) || (cardValid != null && !cardValid)" class="error">Card number is blank or invalid</div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-6">
                        <div class="form-floating">
                            <select class="form-select" id="floatingPaymentMonth" v-model="store.paymentExpireMonth" :class="{ 'is-invalid': v$.paymentExpireMonth.$errors.length > 0 }" @blur="v$.paymentExpireMonth.$touch()">
                                <option v-for="month in 12" :value="month">
                                    {{ month }}
                                </option>
                            </select>
                            <label for="floatingPaymentMonth">Expiration month: <span class="required">*</span></label>
                            <div v-for="error of v$.paymentExpireMonth.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-floating">
                            <select class="form-select" id="floatingPaymentYear" v-model="store.paymentExpireYear" :class="{ 'is-invalid': v$.paymentExpireYear.$errors.length > 0 }" @blur="v$.paymentExpireYear.$touch()">
                                <option v-for="year in 11" :value="2025 + year">
                                    {{ 2025 + year }}
                                </option>
                            </select>
                            <label for="floatingPaymentYear">Expiration year: <span class="required">*</span></label>
                            <div v-for="error of v$.paymentExpireYear.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                        </div>
                    </div>
                </div>

                <div class="mb-3">
                    <div class="form-floating">
                        <div type="text" class="form-control" id="floatingPaymentCVV" placeholder="" :class="{ 'is-invalid': ((codeEmpty != null && codeEmpty) || (codeValid != null && !codeValid)) }"></div>
                        <label for="floatingPaymentCVV">Security code: <span class="required">*</span></label>
                        <div v-if="(codeEmpty != null && codeEmpty) || (codeValid != null && !codeValid)" class="error">Security code is blank or invalid</div>
                    </div>
                </div>

                <div class="mb-3">
                    <div class="text-center">
                        <button type="button" class="btn btn-outline-primary me-3" @click="goBackToPage('AIRCRAFT')">Back</button>
                        <button type="button" class="btn btn-primary" id="buttonPayment">Next</button>
                    </div>
                </div>

            </form>
        </div>
    </section>
</template>

<style>
    #floatingPaymentCardNumber, #floatingPaymentCVV {
        height: 38px;
    }

    .flex-microform-focused {
        background-color: #fff;
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
    }
</style>

<script setup>
    import { computed, ref, nextTick, watch } from 'vue';
    import { useStore } from './store';
    import useVuelidate from '@vuelidate/core';
    import { required, email, helpers } from '@vuelidate/validators';

    const store = useStore();

    const emit = defineEmits(['goToPage', 'goBackToPage']);

    const props = defineProps({
        visible: Boolean
    });

    function goToPage(page) {
        emit('goToPage', page);
    }

    function goBackToPage(page) {
        emit('goBackToPage', page);
    }

    const expirationNotPast = () => {
        if (!store.paymentExpireMonth || !store.paymentExpireYear) {
            return true;
        }

        const expiration = (Number(store.paymentExpireYear) * 12) + Number(store.paymentExpireMonth);

        const now = new Date();

        const current = (now.getFullYear() * 12) + (now.getMonth() + 1);

        return expiration >= current;
    }

    const rules = computed(() => ({
        paymentFirstName: { required },
        paymentLastName: { required },
        paymentAddress1: { required },
        paymentLocality: { required },
        paymentRegion: { required },
        paymentPostalCode: { required },
        paymentCountry: { required },
        paymentEmail: { required, email },
        paymentPhone: { required },
        paymentExpireMonth: { required },
        paymentExpireYear: { required, expirationNotPast: helpers.withMessage('The credit card expiration date has passed.', expirationNotPast) },
    }));

    const v$ = useVuelidate(rules, store);

    let cardNumberState = {
        empty: true,
        valid: false
    };

    let securityCodeState = {
        empty: true,
        valid: false
    };

    const cardEmpty = ref(null);
    const cardValid = ref(null);
    const codeEmpty = ref(null);
    const codeValid = ref(null);
    const submitTried = ref(false);

    async function runWhenVisible() {
        await nextTick();

        $.ajax({
            url: store.estimateFeeUrl + `?landingWeight=${store.aircraftMaxLandingWeight}&landingTime=${store.arrivalDate}`,
            method: 'GET',
            success: function (response) {
                store.estimatedFee = response;
            }
        });

        var form = document.querySelector('#formPayment');
        var payButton = document.querySelector('#buttonPayment');
        var expMonth = document.querySelector('#floatingPaymentMonth');
        var expYear = document.querySelector('#floatingPaymentYear');
        var errorsOutput = document.querySelector('#paymentErrors');

        var captureContext = store.jwt;

        var myStyles = {
            'input': {
                'font-size': '14px'
            },
            ':disabled': { 'cursor': 'not-allowed' }
        };

        var flex = new Flex(captureContext);
        var microform = flex.microform({ styles: myStyles });

        var number = microform.createField('number', { placeholder: '' });
        var securityCode = microform.createField('securityCode', { placeholder: '' });

        number.on('change', function (data) {
            cardNumberState.empty = data.empty;
            cardNumberState.valid = data.valid;

            cardEmpty.value = cardNumberState.empty;
            if (submitTried.value)
                cardValid.value = cardNumberState.valid;
        });

        securityCode.on('change', function (data) {
            securityCodeState.empty = data.empty;
            securityCodeState.valid = data.valid;

            codeEmpty.value = securityCodeState.empty;
            if (submitTried.value)
                codeValid.value = securityCodeState.valid;
        });

        number.load('#floatingPaymentCardNumber');
        securityCode.load('#floatingPaymentCVV');

        payButton.addEventListener('click', async function () {

            submitTried.value = true;

            var isValid = await v$.value.$validate();

            var options = {
                expirationMonth: expMonth.value.padStart(2, '0'),
                expirationYear: expYear.value
            };

            cardEmpty.value = cardNumberState.empty;
            cardValid.value = cardNumberState.valid;

            codeEmpty.value = securityCodeState.empty;
            codeValid.value = securityCodeState.valid;

            if (!isValid || cardEmpty.value || !cardValid.value || codeEmpty.value || !codeValid.value)
                return;

            microform.createToken(options, function (err, token) {
                if (err) {
                    // handle error - obsolete
                    // if (err.details.length > 0) {
                    //     _.forEach(err.details, error => {
                    //         if (error.location == 'number') {
                    //             store.errors.payment.paymentCardNumber = true;
                    //         }
                    //         if (error.location == 'securityCode') {
                    //             store.errors.payment.paymentCvv = true;
                    //         }
                    //     });
                    // }
                    //errorsOutput.textContent = err.message;
                } else {
                    // At this point you may pass the token back to your server as you wish.
                    // In this example we append a hidden input to the form and submit it.
                    store.flexResponse = JSON.stringify(token);
                    goToPage('REVIEW');
                }
            });
        });
    }

    watch(() => props.visible, async (isVisible) => {
        if (isVisible) {
            await runWhenVisible();
        }
    },
    { immediate: true }
    )

</script>